import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
/* jhipster-needle-add-search-module-import - JHipster will add admin modules imports here */
import { SearchPageComponent } from './search-page.component';
@NgModule({
  imports: [
    /* jhipster-needle-add-search-module - JHipster will add search modules here */
    RouterModule.forChild([
      {
        path: 'search',
        component: SearchPageComponent,
        
        /*resolve: {
          cbicSearchOutput: CbicSearchPageRoutingResolveService,
        },*/
        data: {
          pageTitle: 'search.title',
        },
      }
      /* jhipster-needle-add-search-route - JHipster will add search routes here */
    ]),
  ],
})
export class SearchPageRoutingModule {}
